// removed by extract-text-webpack-plugin
module.exports = {"label":"_22t6O7x_CUbEAhALHx_EcZ","labelText":"_2JmvFByUWY-5jRP0wgbdDi","select":"_1Ae8IsSTGEAR6Ui1IoscQr"};


//////////////////
// WEBPACK FOOTER
// ./src/react/ui/Dropdown.styl
// module id = 729
// module chunks = 0